/**
 * Video recording utilities for PresentationVideo component.
 * Extracted to reduce component complexity.
 */

const API = process.env.REACT_APP_BACKEND_URL;

// Canvas slide data for video recording
export const CANVAS_SLIDES = [
  { label: "", title: "CMES", subtitle: "La pharmacie d'officine\nmérite mieux\n\nINTEL-STOCK | CMES-LOG | TECH-CONSEIL", footer: "COACHING MÉDICAL ET ÉPANOUISSEMENT SOCIAL",
    bgType: "gradient", bgC1: "#e0f2fe", bgC2: "#dbeafe", textColor: "#0c4a6e", accentColor: "#0369a1", footerColor: "#334155", align: "center" },
  { label: "LE QUOTIDIEN DES OFFICINES", title: "Entre patients et factures,\nle temps manque cruellement", subtitle: "Votre métier, c'est soigner. Pas gérer de la paperasse.",
    bgType: "image", imgKey: "pharmacy", overlayColor: "0,0,0", overlayAlpha: 0.7, textColor: "#ffffff", accentColor: "#7dd3fc", align: "bottom" },
  { label: "LE CONSTAT", title: "Des millions de FCFA\nperdus chaque mois", subtitle: "\u2022 Factures égarées ou oubliées\n\u2022 Retards de paiement non détectés\n\u2022 Périmés non tracés, stocks inconnus\n\u2022 Des heures perdues en gestion manuelle",
    bgType: "image", imgKey: "papers", overlayColor: "127,29,29", overlayAlpha: 0.82, textColor: "#ffffff", accentColor: "#fca5a5", align: "center" },
  { label: "LA SOLUTION", title: "CMES transforme\nvotre quotidien", subtitle: "Trois services complémentaires pour automatiser\nla gestion complète de votre officine.",
    bgType: "image", imgKey: "dashboard", overlayColor: "6,78,59", overlayAlpha: 0.8, textColor: "#ffffff", accentColor: "#6ee7b7", align: "center" },
  { label: "SERVICE 1 — CMES-LOG", title: "Facturation et logistique\nsans effort", subtitle: "\u2713 Scan OCR intelligent des factures\n\u2713 Pipeline Kanban du dépôt au paiement\n\u2713 Alertes retards automatiques\n\u2713 Prévisions de trésorerie IA",
    bgType: "gradient", bgC1: "#eff6ff", bgC2: "#dbeafe", textColor: "#1e293b", accentColor: "#2563eb", align: "center" },
  { label: "LOGISTIQUE INTÉGRÉE", title: "Suivi de bout en bout\nde vos agents commerciaux", subtitle: "\u2713 GPS temps réel de chaque course\n\u2713 Preuves photo et signature numérique\n\u2713 Traçabilité complète des factures\n\u2713 Messagerie assureurs intégrée",
    bgType: "image", imgKey: "courier", overlayColor: "15,23,42", overlayAlpha: 0.8, textColor: "#ffffff", accentColor: "#67e8f9", align: "bottom" },
  { label: "SERVICE 2 — INTEL-STOCK", title: "Gestion des stocks\net des périmés", subtitle: "\u2713 Alertes péremption intelligentes\n\u2713 Destructions sécurisées avec QR code\n\u2713 Attestations de destruction certifiées\n\u2713 Import CSV et API Caisse",
    bgType: "image", imgKey: "stockshelves", overlayColor: "6,95,70", overlayAlpha: 0.82, textColor: "#ffffff", accentColor: "#6ee7b7", align: "center" },
  { label: "INTEL-STOCK — ANALYSES", title: "Des analyses avancées\npour votre stock", subtitle: "\u2713 Cartographie de tonnage Côte d'Ivoire\n\u2713 Détection des invendus (>90 jours)\n\u2713 Indicateurs ITPP et PharmExchange\n\u2713 Recommandations IA personnalisées",
    bgType: "image", imgKey: "medicines", overlayColor: "120,53,15", overlayAlpha: 0.82, textColor: "#ffffff", accentColor: "#fdba74", align: "center" },
  { label: "SERVICE 3 — TECH-CONSEIL", title: "L'intelligence artificielle\nau service du pharmacien", subtitle: "\u2713 Copilot IA : analyse d'ordonnances en temps réel\n\u2713 Détection d'interactions médicamenteuses\n\u2713 Profil Patient Virtuel (Digital Twin)\n\u2713 Google du Médicament africain",
    bgType: "image", imgKey: "aibrain", overlayColor: "88,28,135", overlayAlpha: 0.85, textColor: "#ffffff", accentColor: "#c084fc", align: "center" },
  { label: "TECH-CONSEIL — MODULES", title: "Sécurité du patient\nau coeur de chaque décision", subtitle: "\u2713 Alertes grossesse et contre-indications\n\u2713 Score qualité de votre officine\n\u2713 Historique complet des analyses IA\n\u2713 Pharmacovigilance avancée",
    bgType: "image", imgKey: "aipill", overlayColor: "67,56,202", overlayAlpha: 0.85, textColor: "#ffffff", accentColor: "#a78bfa", align: "center" },
  { label: "DES FORMULES ADAPTÉES", title: "Choisissez la formule\nqui vous correspond", subtitle: "Services individuels ou combinés\nCombo 2 services avec remise\nFormule Excellence tout-en-un\nEssai gratuit 30 jours",
    bgType: "gradient", bgC1: "#fef3c7", bgC2: "#fde68a", textColor: "#1e293b", accentColor: "#d97706", align: "center" },
  { label: "PORTAIL B2B", title: "Connecté directement\naux assureurs", subtitle: "Messagerie sécurisée, réconciliation automatique\ndes paiements, portail dédié.",
    bgType: "image", imgKey: "handshake", overlayColor: "49,46,129", overlayAlpha: 0.8, textColor: "#ffffff", accentColor: "#a5b4fc", align: "center" },
  { label: "REJOIGNEZ-NOUS", title: "CMES\nTrois services. Une vision.", subtitle: "contact@cmes-pharma.org\n07 68 12 70 00\nAbidjan, Côte d'Ivoire",
    bgType: "image", imgKey: "team", overlayColor: "12,74,110", overlayAlpha: 0.85, textColor: "#ffffff", accentColor: "#7dd3fc", align: "center" },
];

export const IMAGES = {
  pharmacy: "https://images.unsplash.com/photo-1576091358783-a212ec293ff3?w=1400&q=80",
  papers: "https://images.unsplash.com/photo-1566699270403-3f7e3f340664?w=1400&q=80",
  dashboard: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?w=1400&q=80",
  pipeline: "https://images.unsplash.com/photo-1758876020010-fe9a9d9f8266?w=1400&q=80",
  courier: "https://images.unsplash.com/photo-1762381294809-d83de0303511?w=1400&q=80",
  handshake: "https://images.unsplash.com/photo-1739285452618-0b7b3d04f953?w=1400&q=80",
  team: "https://images.unsplash.com/photo-1758691737584-a8f17fb34475?w=1400&q=80",
  aibrain: "https://images.unsplash.com/photo-1674027215032-f0c4292318ee?w=1400&q=80",
  aipill: "https://images.unsplash.com/photo-1639991987087-f28545e9b1f2?w=1400&q=80",
  stockshelves: "https://images.unsplash.com/photo-1579105878454-bf8d4cc5081e?w=1400&q=80",
  medicines: "https://images.unsplash.com/photo-1543709533-c032159da7b0?w=1400&q=80",
};

export function drawSlideOnCanvas(ctx, w, h, slideData, img, opts = {}) {
  const { logo, fadeAlpha } = opts;
  ctx.fillStyle = "#0f172a";
  ctx.fillRect(0, 0, w, h);

  if (slideData.bgType === "image" && img) {
    try {
      const iw = img.width, ih = img.height;
      const scale = Math.max(w / iw, h / ih);
      const sx = (w - iw * scale) / 2, sy = (h - ih * scale) / 2;
      ctx.drawImage(img, sx, sy, iw * scale, ih * scale);
    } catch { /* dark bg remains */ }
    ctx.fillStyle = `rgba(${slideData.overlayColor},${slideData.overlayAlpha})`;
    ctx.fillRect(0, 0, w, h);
  } else if (slideData.bgType === "image") {
    const colors = (slideData.overlayColor || "30,41,59").split(",").map(Number);
    ctx.fillStyle = `rgb(${colors[0]},${colors[1]},${colors[2]})`;
    ctx.fillRect(0, 0, w, h);
  } else {
    const grd = ctx.createLinearGradient(0, 0, w, h);
    grd.addColorStop(0, slideData.bgC1 || "#e0f2fe");
    grd.addColorStop(0.5, slideData.bgC2 || "#dbeafe");
    grd.addColorStop(1, slideData.bgC1 || "#e0f2fe");
    ctx.fillStyle = grd;
    ctx.fillRect(0, 0, w, h);
    const radGrd = ctx.createRadialGradient(w * 0.3, h * 0.4, 0, w * 0.3, h * 0.4, w * 0.5);
    radGrd.addColorStop(0, "rgba(147,197,253,0.15)");
    radGrd.addColorStop(1, "rgba(147,197,253,0)");
    ctx.fillStyle = radGrd;
    ctx.fillRect(0, 0, w, h);
  }

  const centerY = slideData.align === "bottom" ? h * 0.55 : h * 0.35;
  const isImage = slideData.bgType === "image";

  if (slideData.label) {
    ctx.save();
    ctx.font = `900 ${Math.round(w * 0.013)}px 'Segoe UI', Arial, sans-serif`;
    ctx.fillStyle = slideData.accentColor;
    ctx.textAlign = "center";
    ctx.letterSpacing = "6px";
    if (isImage) { ctx.shadowColor = "rgba(0,0,0,0.8)"; ctx.shadowBlur = 10; }
    ctx.fillText(slideData.label, w / 2, centerY);
    ctx.restore();
  }

  const titleFontSize = Math.round(w * 0.04);
  ctx.font = `900 ${titleFontSize}px 'Segoe UI', Arial, sans-serif`;
  ctx.textAlign = "center";
  const titleLines = (slideData.title || "").split("\n");
  const titleY = centerY + (slideData.label ? w * 0.045 : 0);
  const lineHeight = titleFontSize * 1.2;
  titleLines.forEach((line, i) => {
    ctx.save();
    ctx.fillStyle = i > 0 ? slideData.accentColor : slideData.textColor;
    if (isImage) { ctx.shadowColor = "rgba(0,0,0,0.9)"; ctx.shadowBlur = 20; ctx.shadowOffsetY = 3; }
    ctx.fillText(line, w / 2, titleY + i * lineHeight);
    ctx.restore();
  });

  if (!isImage && titleLines.length > 0) {
    const lineY = titleY + titleLines.length * lineHeight + 10;
    const lineW = w * 0.08;
    const lineGrd = ctx.createLinearGradient(w / 2 - lineW / 2, lineY, w / 2 + lineW / 2, lineY);
    lineGrd.addColorStop(0, "transparent");
    lineGrd.addColorStop(0.3, slideData.accentColor || "#0369a1");
    lineGrd.addColorStop(0.7, slideData.accentColor || "#0369a1");
    lineGrd.addColorStop(1, "transparent");
    ctx.fillStyle = lineGrd;
    ctx.fillRect(w / 2 - lineW / 2, lineY, lineW, 4);
  }

  if (slideData.subtitle) {
    const subFontSize = Math.round(w * 0.018);
    ctx.font = `500 ${subFontSize}px 'Segoe UI', Arial, sans-serif`;
    ctx.fillStyle = slideData.textColor;
    ctx.textAlign = "center";
    if (isImage) { ctx.shadowColor = "rgba(0,0,0,0.7)"; ctx.shadowBlur = 12; }
    const subLines = slideData.subtitle.split("\n");
    const subY = titleY + titleLines.length * lineHeight + (isImage ? 25 : 35);
    subLines.forEach((line, i) => { ctx.fillText(line, w / 2, subY + i * (subFontSize * 1.6)); });
    ctx.shadowBlur = 0;
    ctx.shadowColor = "transparent";
  }

  if (slideData.footer) {
    ctx.font = `700 ${Math.round(w * 0.011)}px 'Segoe UI', Arial, sans-serif`;
    ctx.fillStyle = slideData.footerColor || "#334155";
    ctx.textAlign = "center";
    ctx.letterSpacing = "4px";
    ctx.fillText(slideData.footer, w / 2, h * 0.75);
  }

  ctx.fillStyle = isImage ? "rgba(0,0,0,0.3)" : "rgba(0,0,0,0.05)";
  ctx.fillRect(0, h - 40, w, 40);
  ctx.font = `600 ${Math.round(w * 0.008)}px 'Segoe UI', Arial, sans-serif`;
  ctx.fillStyle = isImage ? "rgba(255,255,255,0.4)" : "rgba(0,0,0,0.2)";
  ctx.textAlign = "right";
  ctx.fillText("CMES-LOG \u00b7 cmes.ci", w - 30, h - 14);

  if (logo && (slideData.title === "CMES-LOG" || slideData.title?.includes("Rejoignez"))) {
    const logoSize = Math.round(w * 0.08);
    const logoX = (w - logoSize) / 2;
    const logoY = centerY - logoSize - Math.round(w * 0.04);
    ctx.save();
    ctx.shadowColor = "rgba(0,0,0,0.5)";
    ctx.shadowBlur = 20;
    const r = logoSize * 0.15;
    ctx.beginPath();
    ctx.moveTo(logoX + r, logoY);
    ctx.lineTo(logoX + logoSize - r, logoY);
    ctx.quadraticCurveTo(logoX + logoSize, logoY, logoX + logoSize, logoY + r);
    ctx.lineTo(logoX + logoSize, logoY + logoSize - r);
    ctx.quadraticCurveTo(logoX + logoSize, logoY + logoSize, logoX + logoSize - r, logoY + logoSize);
    ctx.lineTo(logoX + r, logoY + logoSize);
    ctx.quadraticCurveTo(logoX, logoY + logoSize, logoX, logoY + logoSize - r);
    ctx.lineTo(logoX, logoY + r);
    ctx.quadraticCurveTo(logoX, logoY, logoX + r, logoY);
    ctx.closePath();
    ctx.clip();
    ctx.drawImage(logo, logoX, logoY, logoSize, logoSize);
    ctx.restore();
  }

  if (typeof fadeAlpha === "number" && fadeAlpha > 0) {
    ctx.fillStyle = `rgba(0,0,0,${fadeAlpha})`;
    ctx.fillRect(0, 0, w, h);
  }
}

export async function recordVideo(SLIDES, slideDurations, onProgress) {
  const W = 1920, H = 1080;
  const canvas = document.createElement("canvas");
  canvas.width = W; canvas.height = H;
  canvas.style.cssText = "position:fixed;top:-9999px;left:-9999px;pointer-events:none;";
  document.body.appendChild(canvas);
  const ctx = canvas.getContext("2d", { willReadFrequently: true });

  onProgress({ phase: "Chargement des images...", pct: 5 });
  const loadedImages = {};
  const imgEntries = Object.entries(IMAGES);
  for (let i = 0; i < imgEntries.length; i++) {
    const [key, url] = imgEntries[i];
    for (const fetchUrl of [
      `${API}/api/voiceover/proxy-image?url=${encodeURIComponent(url)}`,
      url,
    ]) {
      try {
        const res = await fetch(fetchUrl);
        if (!res.ok) continue;
        const blob = await res.blob();
        const bitmap = await createImageBitmap(blob);
        loadedImages[key] = bitmap;
        break;
      } catch { /* try next */ }
    }
    onProgress({ phase: "Chargement des images...", pct: 5 + ((i + 1) / imgEntries.length) * 15 });
  }

  let logoImg = null;
  try {
    const logoRes = await fetch("/cmes-logo.png");
    if (logoRes.ok) { logoImg = await createImageBitmap(await logoRes.blob()); }
  } catch { /* no logo */ }

  onProgress({ phase: "Préparation audio...", pct: 22 });
  const audioCtx = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 44100 });
  const audioDest = audioCtx.createMediaStreamDestination();

  const voBuffers = {};
  for (const slide of SLIDES) {
    try {
      const res = await fetch(`${API}/api/voiceover/audio/${slide.id}`);
      if (!res.ok) continue;
      const ab = await res.arrayBuffer();
      voBuffers[slide.id] = await audioCtx.decodeAudioData(ab);
    } catch { /* skip */ }
  }

  const videoStream = canvas.captureStream(0);
  const videoTrack = videoStream.getVideoTracks()[0];
  const combined = new MediaStream([videoTrack, ...audioDest.stream.getTracks()]);
  const mimeType = MediaRecorder.isTypeSupported("video/webm;codecs=vp9,opus")
    ? "video/webm;codecs=vp9,opus" : "video/webm";
  const recorder = new MediaRecorder(combined, { mimeType, videoBitsPerSecond: 5000000 });
  const chunks = [];
  recorder.ondataavailable = (e) => { if (e.data.size > 0) chunks.push(e.data); };

  const firstSlide = CANVAS_SLIDES[0];
  const firstImg = firstSlide.imgKey ? loadedImages[firstSlide.imgKey] : null;
  drawSlideOnCanvas(ctx, W, H, firstSlide, firstImg, { logo: logoImg });
  videoTrack.requestFrame();

  recorder.start(500);

  onProgress({ phase: "Enregistrement en cours...", pct: 25 });
  const totalMs = slideDurations.reduce((s, d) => s + d, 0);
  let elapsed = 0;

  for (let si = 0; si < SLIDES.length; si++) {
    const dur = slideDurations[si] || SLIDES[si].duration;
    const slideData = CANVAS_SLIDES[si];
    const img = slideData.imgKey ? loadedImages[slideData.imgKey] : null;

    if (voBuffers[SLIDES[si].id]) {
      const src = audioCtx.createBufferSource();
      src.buffer = voBuffers[SLIDES[si].id];
      src.connect(audioDest);
      src.start();
    }

    const FADE_DUR = 800;
    const startT = Date.now();
    const frameInterval = 1000 / 24;
    let lastFrameT = 0;
    while (Date.now() - startT < dur) {
      const now = Date.now();
      if (now - lastFrameT >= frameInterval) {
        const elapsedInSlide = now - startT;
        let fadeAlpha = 0;
        if (si > 0 && elapsedInSlide < FADE_DUR) fadeAlpha = 1 - (elapsedInSlide / FADE_DUR);
        if (elapsedInSlide > dur - FADE_DUR) fadeAlpha = Math.max(fadeAlpha, (elapsedInSlide - (dur - FADE_DUR)) / FADE_DUR);
        drawSlideOnCanvas(ctx, W, H, slideData, img, { logo: logoImg, fadeAlpha });
        videoTrack.requestFrame();
        lastFrameT = now;
      }
      await new Promise((r) => setTimeout(r, 10));
      elapsed = slideDurations.slice(0, si).reduce((s, d) => s + d, 0) + (Date.now() - startT);
      const pct = 25 + (elapsed / totalMs) * 70;
      onProgress({ phase: `Slide ${si + 1}/${SLIDES.length}...`, pct: Math.min(pct, 95) });
    }
  }

  recorder.stop();
  await new Promise((r) => { recorder.onstop = r; });
  audioCtx.close();
  canvas.remove();

  onProgress({ phase: "Téléchargement...", pct: 98 });
  const blob = new Blob(chunks, { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "CMES-LOG_Presentation.webm";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  onProgress({ phase: "Terminé !", pct: 100 });
}

export function createBackgroundMusic(audioCtx) {
  const masterGain = audioCtx.createGain();
  masterGain.gain.value = 0.28;

  const dryGain = audioCtx.createGain();
  dryGain.gain.value = 0.65;
  const wetGain = audioCtx.createGain();
  wetGain.gain.value = 0.35;
  const delay1 = audioCtx.createDelay(1.0);
  delay1.delayTime.value = 0.3;
  const fb1 = audioCtx.createGain();
  fb1.gain.value = 0.2;
  const delay2 = audioCtx.createDelay(1.0);
  delay2.delayTime.value = 0.5;
  const fb2 = audioCtx.createGain();
  fb2.gain.value = 0.12;

  masterGain.connect(dryGain);
  masterGain.connect(delay1);
  delay1.connect(fb1); fb1.connect(delay1);
  delay1.connect(delay2);
  delay2.connect(fb2); fb2.connect(delay2);
  delay1.connect(wetGain); delay2.connect(wetGain);

  const merger = audioCtx.createGain();
  dryGain.connect(merger);
  wetGain.connect(merger);

  const finalFilter = audioCtx.createBiquadFilter();
  finalFilter.type = "lowpass";
  finalFilter.frequency.value = 5000;
  finalFilter.Q.value = 0.4;
  merger.connect(finalFilter);

  const SOFT_CHORDS = [
    { bass: 110.00, notes: [220.00, 261.63, 329.63] },
    { bass: 130.81, notes: [196.00, 261.63, 329.63] },
    { bass: 146.83, notes: [220.00, 261.63, 349.23] },
    { bass: 164.81, notes: [196.00, 246.94, 329.63] },
  ];
  const SOFT_BPM = 60;

  const EPIC_CHORDS = [
    { bass: 130.81, notes: [261.63, 329.63, 392.00, 523.25] },
    { bass: 196.00, notes: [246.94, 329.63, 392.00, 493.88] },
    { bass: 174.61, notes: [261.63, 349.23, 440.00, 523.25] },
    { bass: 146.83, notes: [220.00, 293.66, 349.23, 440.00] },
    { bass: 130.81, notes: [261.63, 329.63, 392.00, 523.25] },
    { bass: 174.61, notes: [261.63, 349.23, 523.25, 698.46] },
    { bass: 196.00, notes: [293.66, 392.00, 493.88, 587.33] },
    { bass: 220.00, notes: [261.63, 329.63, 440.00, 523.25] },
  ];
  const EPIC_BPM = 120;

  let beatIndex = 0;
  let timer = null;
  let currentPhase = 1;

  function playTone(freq, type, volume, attack, sustain, release) {
    if (!audioCtx || audioCtx.state === "closed") return;
    const osc = audioCtx.createOscillator();
    osc.type = type;
    osc.frequency.value = freq;
    const g = audioCtx.createGain();
    g.gain.value = 0;
    osc.connect(g).connect(masterGain);
    const now = audioCtx.currentTime;
    g.gain.setValueAtTime(0, now);
    g.gain.linearRampToValueAtTime(volume, now + attack);
    g.gain.setValueAtTime(volume * 0.8, now + attack + sustain);
    g.gain.exponentialRampToValueAtTime(0.001, now + attack + sustain + release);
    osc.start(now);
    osc.stop(now + attack + sustain + release + 0.05);
    osc.onended = () => { try { osc.disconnect(); g.disconnect(); } catch {} };
  }

  function playPianoNote(freq, vol) {
    playTone(freq, "sine", vol, 0.01, 0.3, 1.2);
    playTone(freq * 2, "sine", vol * 0.15, 0.005, 0.15, 0.6);
  }

  function playSoftBeat() {
    if (!audioCtx || audioCtx.state !== "running") return;
    const chordIdx = Math.floor(beatIndex / 4) % SOFT_CHORDS.length;
    const chord = SOFT_CHORDS[chordIdx];
    const pos = beatIndex % 4;
    if (pos === 0) playTone(chord.bass, "sine", 0.10, 0.05, 0.8, 1.5);
    if (pos < chord.notes.length) playPianoNote(chord.notes[pos], 0.08);
    if (pos === 0) chord.notes.forEach((n) => { playTone(n * 0.5, "sine", 0.025, 0.8, 2.0, 1.5); });
    beatIndex++;
  }

  function playEpicBeat() {
    if (!audioCtx || audioCtx.state !== "running") return;
    const chordIdx = Math.floor(beatIndex / 8) % EPIC_CHORDS.length;
    const chord = EPIC_CHORDS[chordIdx];
    const pos = beatIndex % 8;
    if (pos === 0) playTone(chord.bass, "sine", 0.16, 0.02, 0.15, 0.3);
    if (pos === 4) playTone(chord.bass, "sine", 0.12, 0.02, 0.12, 0.25);
    if (pos === 2 || pos === 6) playTone(chord.bass * 2, "sine", 0.06, 0.01, 0.08, 0.15);
    const noteIdx = pos < 4 ? pos % chord.notes.length : (7 - pos) % chord.notes.length;
    const freq = chord.notes[noteIdx];
    playTone(freq, "triangle", 0.09, 0.01, 0.08, 0.15);
    if (pos === 0 || pos === 4) playTone(freq * 2, "sine", 0.025, 0.05, 0.1, 0.3);
    if (pos % 2 === 0) chord.notes.slice(0, 3).forEach((n) => { playTone(n, "square", 0.012, 0.005, 0.04, 0.08); });
    if (pos === 0) chord.notes.forEach((n) => { playTone(n * 0.5, "sine", 0.03, 0.3, 1.0, 0.8); });
    if (pos === 3 || pos === 7) {
      const melodyFreq = chord.notes[chord.notes.length - 1];
      playTone(melodyFreq * 1.5, "sine", 0.035, 0.02, 0.1, 0.3);
    }
    beatIndex++;
  }

  function startArpeggio() {
    beatIndex = 0;
    currentPhase = 1;
    const beatMs = 60000 / SOFT_BPM;
    playSoftBeat();
    timer = setInterval(playSoftBeat, beatMs);
  }

  function switchToPhase2() {
    if (currentPhase === 2) return;
    currentPhase = 2;
    beatIndex = 0;
    if (timer) clearInterval(timer);
    setTimeout(() => {
      const beatMs = 60000 / EPIC_BPM;
      masterGain.gain.setValueAtTime(0.15, audioCtx.currentTime);
      masterGain.gain.linearRampToValueAtTime(0.32, audioCtx.currentTime + 2.0);
      playEpicBeat();
      timer = setInterval(playEpicBeat, beatMs);
    }, 400);
  }

  function stopArpeggio() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  return { output: finalFilter, oscillators: [], gainNode: masterGain, startArpeggio, stopArpeggio, switchToPhase2 };
}
